import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert
} from "reactstrap"
import apiResponse from '../../../../../services/apiResponse';
import DetailBloc from '../Blocs/DetailBloc'

class SaranPengembangan extends Component {

  detailBloc = new DetailBloc()

    constructor(props) {
      super(props)
      this.state = {
        assessment_matrix : this.props.matrixid,
        assessmentuuid : this.props.uuid,
        assDdevGuide : [{}]
      }
    }
    loadDevGuide = async () => {
      const query = {
          uuid: this.state.assessmentuuid
      }
      // console.log(query)
      await this.detailBloc.fetchDevGuide(query)
    }
    componentDidMount() {
        // console.log('assessmentuuid')
        // console.log(this.state.assessmentuuid)
      this.loadDevGuide()
      this.detailBloc.devGuideChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log('saran')
                      // console.log(response)
                      this.setState({
                          assDdevGuide : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      
  }
    render() {
      return (
        <Fragment>
          <br />
          <table className="table table-striped table-bordered">
            <tbody>

          {
            this.state.assDdevGuide.map((data,index)=>{
              
              return(
                <tr>
                  <th>{(index+1)}</th>
                  <td>
                    <b>{data.kompetensi}</b>
                    <div>
                      <ul>
                    {
                      data.saran?.map((dt,i)=>{
                        return(
                          <li>{dt}</li>
                          )
                        })
                      }
                      </ul>
                    </div>
                  </td>
                </tr>
              )
            })
          }
          </tbody>
        </table>
        </Fragment>
      )
    }
  }
  export default SaranPengembangan